import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import style from "../../styles/brands.module.scss";
import { imageUrl } from "../../baseApi";
const Brands = ({ data = [] }) => {
  return (
    <>
      <Swiper
        className={style.brandsSwiper}
        slidesPerView={5}
        spaceBetween={30}
        loop
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        breakpoints={{
          1200: {
            slidesPerView: 5,
          },
          1024: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
          650: {
            slidesPerView: 3,
          },
          480: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 1,
          },
          300: {
            slidesPerView: 1,
          },
        }}
      >
        {data?.logos?.map((logo) => {
          return (
            <SwiperSlide className={style.brands} key={logo?.id}>
              <img src={imageUrl + logo?.url} alt="Holiday Depialtori" />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default Brands;
